import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  MenuItem,
  Typography,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Grid,
  Card,
  CardContent,
  FormControl,
  Select,
} from "@mui/material";
import CustomYesNoModal from "../../../../micro_components/CustomYesNoModal";
import CustomDialog from "../PopupPropertiesMenu/CustomDialog";
import HeresAmericaService from "../../../../../services/HA/HeresAmericaService";
import {
  displaySuccessToast,
  displayErrorToast,
} from "../../../../../utils/toast";
import DialogPopup from "../PopupPropertiesMenu/QuizModule/DialogPopup";
import { Answer, DragDropAnswer } from "./Answer";
const CrudQuizComponent = ({
  quizData,
  lang,
  setHasUnsavedQuizChanges,
  hasUnsavedQuizChanges,
}) => {
  const [quiz, setQuiz] = useState(quizData);
  const [editState, setEditState] = useState({});
  const [originalQuiz, setOriginalQuiz] = useState(quizData);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (questionIndex, answerIndex, newValue, field) => {
    const updatedQuiz = { ...quiz };
    setHasUnsavedQuizChanges(true);
    switch (field) {
      case "title":
        updatedQuiz.title[lang] = newValue;
        break;
      case "isOpenBook":
        updatedQuiz.isOpenBook = newValue;
        break;
      case "quizType":
        updatedQuiz.quizType = newValue;
        break;
      case "type":
        updatedQuiz.questions[questionIndex].type = newValue;
        break;
      case "isCorrect":
        if (answerIndex !== null) {
          updatedQuiz.questions[questionIndex].answers[answerIndex].isCorrect =
            newValue;
        }
        break;
      case "attemptsAllowed":
        updatedQuiz.questions[questionIndex].attemptsAllowed = newValue;
        break;
      case "posFeedback":
      case "negFeedback":
        if (!updatedQuiz.questions[questionIndex].feedback) {
          updatedQuiz.questions[questionIndex].feedback = {};
        }
        if (!updatedQuiz.questions[questionIndex].feedback[lang]) {
          updatedQuiz.questions[questionIndex].feedback[lang] = {
            pos: "",
            neg: "",
          };
        }
        updatedQuiz.questions[questionIndex].feedback[lang][
          field === "posFeedback" ? "pos" : "neg"
        ] = newValue;
        break;
      default:
        if (answerIndex !== null) {
          if (updatedQuiz.questions[questionIndex].type === "dragDropPair") {
            updatedQuiz.questions[questionIndex].answers[answerIndex].text[
              field
            ][lang] = newValue;

            break;
          }
          updatedQuiz.questions[questionIndex].answers[answerIndex].text[lang] =
            newValue;
        } else {
          if (!updatedQuiz.questions[questionIndex].text) {
            updatedQuiz.questions[questionIndex].text = {};
          }
          updatedQuiz.questions[questionIndex].text[lang] = newValue;
        }
        break;
    }

    setQuiz(updatedQuiz);
  };

  const toggleEdit = (qIndex, aIndex = null) => {
    const key = `${qIndex}-${aIndex}`;
    setEditState({ ...editState, [key]: !editState[key] });

    // if (!editState[key]) {
    //   setOriginalQuiz({ ...quiz });
    // } else {
    //   setQuiz({ ...originalQuiz });
    // }
  };

  const handleSaveAll = async () => {
    setLoading(true);
    if (hasUnsavedQuizChanges) {
      setHasUnsavedQuizChanges(false);
    }
    try {
      await HeresAmericaService.updateQuiz(quiz.externalBookId, quiz.id, {
        title: quiz.title,
        quizType: quiz.quizType,
        isOpenBook: quiz.isOpenBook,
      });

      const updatedQuestions = [];
      console.log(quiz.questions);
      for (const [qIndex, question] of quiz.questions.entries()) {
        let updatedQuestion;
        updatedQuestion = question.id
          ? await HeresAmericaService.updateQuestion(question.id, question)
          : await HeresAmericaService.createQuestion(question);
        updatedQuestion.answers = [];

        for (const [aIndex, answer] of question.answers.entries()) {
          console.log(
            "🚀 ~ file: CrudQuizComponent.jsx ~ line 116 ~ handleSaveAll ~ answer",
            answer
          );
          const updatedAnswer = answer.id
            ? await HeresAmericaService.updateAnswerById(answer.id, answer)
            : await HeresAmericaService.createAnswer({
                questionId: updatedQuestion.id,
                text: answer.text,
                isCorrect: answer.isCorrect,
              }); // Pass questionId here
          updatedQuestion.answers[aIndex] = updatedAnswer;
        }

        updatedQuestions[qIndex] = updatedQuestion;
      }

      setQuiz((prevQuiz) => ({ ...prevQuiz, questions: updatedQuestions }));
      displaySuccessToast("Quiz saved successfully!");
    } catch (error) {
      console.error(error);
      displayErrorToast("An error occurred while saving the quiz.");
    } finally {
      setEditState({});
      setLoading(false);
    }
  };

  async function translateQuizFields(quiz, targetLanguage) {
    if (targetLanguage === "en") {
      displayErrorToast("Cannot translate to English");
    }
    if (quiz.title.en && !quiz.title[targetLanguage]) {
      quiz.title[targetLanguage] = await HeresAmericaService.translateText(
        quiz.title.en,
        targetLanguage
      );
    }

    for (const question of quiz.questions) {
      if (question.text.en && !question.text[targetLanguage]) {
        question.text[targetLanguage] = await HeresAmericaService.translateText(
          question.text.en,
          targetLanguage
        );
      }

      if (question.feedback?.en) {
        if (
          question.feedback?.en?.neg &&
          !question.feedback[targetLanguage]?.neg
        ) {
          question.feedback[targetLanguage] =
            question.feedback[targetLanguage] || {};
          question.feedback[targetLanguage].neg =
            await HeresAmericaService.translateText(
              question.feedback.en.neg,
              targetLanguage
            );
        }
        if (
          question.feedback?.en?.pos &&
          !question.feedback[targetLanguage]?.pos
        ) {
          question.feedback[targetLanguage] =
            question.feedback[targetLanguage] || {};
          question.feedback[targetLanguage].pos =
            await HeresAmericaService.translateText(
              question.feedback.en.pos,
              targetLanguage
            );
        }
      }

      for (const answer of question.answers) {
        if (question.type === "dragDropPair") {
          console.log(answer);
          if (answer.text.a.en && !answer.text.a[targetLanguage]) {
            answer.text.a[targetLanguage] =
              await HeresAmericaService.translateText(
                answer.text.a.en,
                targetLanguage
              );
          }
          if (answer.text.b.en && !answer.text.b[targetLanguage]) {
            answer.text.b[targetLanguage] =
              await HeresAmericaService.translateText(
                answer.text.b.en,
                targetLanguage
              );
          }
        } else if (answer.text.en && !answer.text[targetLanguage]) {
          answer.text[targetLanguage] = await HeresAmericaService.translateText(
            answer.text.en,
            targetLanguage
          );
        }
      }
    }
    setLoading(false);
    setQuiz({ ...quiz });
  }
  const handleMediaUpdate = (
    questionIndex,
    answerIndex,
    mediaUrl,
    mediaType
  ) => {
    const updatedQuestions = [...quiz.questions];
    // console.log(  questionIndex,
    //   answerIndex,
    //   mediaUrl,
    //   mediaType)
    if (answerIndex !== null) {
      const answerMedia =
        updatedQuestions[questionIndex]?.answers[answerIndex]?.media;
      const mediaIndex = answerMedia?.findIndex(
        (media) => media.language === lang
      );

      if (mediaIndex > -1) {
        // Replace existing media
        answerMedia[mediaIndex] = {
          ...answerMedia[mediaIndex],
          type: mediaType,
          url: mediaUrl,
          language: lang,
        };
      } else {
        // Push new media
        answerMedia.push({
          type: mediaType,
          url: mediaUrl,
          language: lang,
        });
      }
    } else {
      const questionMedia = updatedQuestions[questionIndex].media;
      const mediaIndex = questionMedia.findIndex(
        (media) => media.language === lang
      );

      if (mediaIndex > -1) {
        // if index found
        // Replace existing media
        questionMedia[mediaIndex] = {
          ...questionMedia[mediaIndex],
          type: mediaType,
          url: mediaUrl,
          language: lang,
        };
      } else {
        // Push new media
        questionMedia.push({
          type: mediaType,
          url: mediaUrl,
          language: lang,
        });
      }
    }

    setQuiz({ ...quiz, questions: updatedQuestions });
  };

  const deleteQuestion = async (questionId, qIndex) => {
    try {
      if (!questionId && qIndex) {
        setQuiz({
          ...quiz,
          questions: quiz.questions.filter((q, index) => index !== qIndex),
        });
        return;
      }
      await HeresAmericaService.deleteQuestion(questionId);
      setQuiz({
        ...quiz,
        questions: quiz.questions.filter((q) => q.id !== questionId),
      });
      displaySuccessToast("Question deleted successfully!");
    } catch (error) {
      console.error(error);
      displayErrorToast("An error occurred while deleting the question.");
    }
  };

  const deleteAnswer = async (questionIndex, answerId) => {
    try {
      await HeresAmericaService.deleteAnswerById(answerId);
      const updatedQuestions = [...quiz.questions];
      updatedQuestions[questionIndex].answers = updatedQuestions[
        questionIndex
      ].answers.filter((a) => a.id !== answerId);
      setQuiz({ ...quiz, questions: updatedQuestions });
      displaySuccessToast("Answer deleted successfully!");
    } catch (error) {
      console.error(error);
      displayErrorToast("An error occurred while deleting the answer.");
    }
  };
  const addQuestion = () => {
    const newQuestion = {
      text: { [lang]: "" },
      quizId: quiz.id,
      type: "multipleChoice",
      attemptsAllowed: 1,
      answers: [],
      media: [],
      feedback: { [lang]: { pos: "", neg: "" } },
      // Add other necessary default values
    };
    setQuiz({ ...quiz, questions: [...quiz.questions, newQuestion] });
  };

  const addAnswer = (qIndex, questionId) => {
    console.log("🚀 ~ addAnswer ~ questionId:", qIndex, questionId);
    const newAnswer = {
      text: { [lang]: "" },
      isCorrect: false,
      questionId: questionId,
      media: [],
      // Add other necessary default values
    };
    console.log("🚀 ~ addAnswer ~ newAnswer:", newAnswer);

    const updatedQuestions = [...quiz.questions];
    updatedQuestions[qIndex].answers.push(newAnswer);
    setQuiz({ ...quiz, questions: updatedQuestions });
  };
  useEffect(() => {
    console.log(quiz);
  }, [quiz]);

  return (
    <Box maxWidth={"90vw"} fullWidth p={2} style={{ overflowY: "scroll" }}>
      {loading ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "60vh",
              width: "600px",
            }}
          >
            <CircularProgress />
          </div>
        </>
      ) : (
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            flexDirection="column"
            fullWidth
          >
            {" "}
            <Box display="flex" justifyContent="space-between" fullWidth>
              {lang === "en" ? (
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Swap language to translate
                </Typography>
              ) : (
                <Button
                  onClick={(e) => {
                    setLoading(true);

                    translateQuizFields(quiz, lang);
                  }}
                  disabled={lang === "en"}
                  loading={loading}
                  color="success"
                  variant="outlined"
                >
                  <span>Translate en to {lang}</span>
                </Button>
              )}{" "}
              <Typography variant="body2" color="GrayText" gutterBottom>
                Quiz ID: {quiz?.id}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <FormControl component="fieldset" mt sx={{ mx: 0.5 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="success"
                      disabled={!editState["title-null"]}
                      checked={quiz.isOpenBook}
                      onChange={(e) =>
                        handleInputChange(
                          null,
                          null,
                          e.target.checked,
                          "isOpenBook"
                        )
                      }
                    />
                  }
                  label={quiz.isOpenBook ? "Open Book" : "Open Book"}
                  labelPlacement="top"
                />
              </FormControl>{" "}
              <TextField
                variant="outlined"
                value={quiz.title[lang]}
                disabled={!editState["title-null"]}
                onChange={(e) =>
                  handleInputChange(null, null, e.target.value, "title")
                }
                style={{ marginRight: 10, width: "100%" }}
              />
              <FormControl fullWidth>
                <Select
                  disabled={!editState["title-null"]}
                  value={quiz.quizType}
                  onChange={(e) =>
                    handleInputChange(null, null, e.target.value, "quizType")
                  }
                >
                  <MenuItem value={"GRADED"}>GRADED</MenuItem>
                  <MenuItem value={"PRACTICE"}>PRACTICE</MenuItem>
                  <MenuItem value={"FLASHCARDS"}>FLASHCARDS</MenuItem>
                </Select>
              </FormControl>{" "}
              <Box>
                <Button
                  color={editState["title-null"] ? "success" : "info"}
                  onClick={() =>
                    editState["title-null"]
                      ? toggleEdit("title", null)
                      : toggleEdit("title", null)
                  }
                >
                  {editState["title-null"] ? "Done" : "Edit"}
                </Button>
              </Box>
            </Box>
          </Box>
          <Grid container spacing={2}>
            {lang &&
              quiz &&
              quiz.questions.map((question, qIndex) => (
                <Grid item xs={12} key={question.id || qIndex}>
                  <Card
                    variant="outlined"
                    style={{
                      backgroundColor: editState[`${qIndex}-null`]
                        ? "#f0f0f0"
                        : "white",
                    }}
                  >
                    <CardContent>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2}
                      >
                        <Typography variant="h6" style={{ marginBottom: 10 }}>
                          Question {qIndex + 1}
                        </Typography>{" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            gap: "10px",
                          }}
                        >
                          {editState[`${qIndex}-null`] && (
                            <>
                              {/* <Button
                                color="warning"
                                onClick={() => toggleEdit(qIndex, null)}
                              >
                                Cancel
                              </Button> */}

                              <CustomDialog
                                buttonText={"delete"}
                                buttonColor="error"
                                bodyContent={`Are you sure you want to delete the question "${question.text[lang]}"? This action will also delete all associated answers and translations.`}
                                onSubmit={() =>
                                  deleteQuestion(question.id, qIndex)
                                }
                              />
                            </>
                          )}
                          <Button
                            color={
                              editState[`${qIndex}-null`] ? "success" : "info"
                            }
                            onClick={() =>
                              editState[`${qIndex}-null`]
                                ? toggleEdit(qIndex, null)
                                : toggleEdit(qIndex, null)
                            }
                          >
                            {editState[`${qIndex}-null`] ? "Done" : "Edit"}
                          </Button>
                        </div>
                      </Box>
                      <Box display="flex" alignItems="center" mb={2}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          value={question.text[lang] || ""}
                          onChange={(e) =>
                            handleInputChange(qIndex, null, e.target.value)
                          }
                          disabled={!editState[`${qIndex}-null`]}
                          style={{ marginRight: 10 }}
                        />
                        {editState[`${qIndex}-null`] && (
                          <>
                            <DialogPopup
                              key={qIndex}
                              questionIndex={qIndex}
                              answerIndex={null}
                              disabled={!editState[`${qIndex}-null`]}
                              media={
                                question?.media?.filter(
                                  (m) => m.language === lang
                                )[0]
                              }
                              onMediaUpdate={handleMediaUpdate}
                              bookId={quiz.externalBookId}
                            />
                          </>
                        )}
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignContent="center"
                        my={2}
                        padding={2}
                      >
                        <TextField
                          label="Positive Feedback"
                          fullWidth
                          variant="standard"
                          value={question?.feedback?.[lang]?.pos ?? ""}
                          onChange={(e) =>
                            handleInputChange(
                              qIndex,
                              null,
                              e.target.value,
                              "posFeedback"
                            )
                          }
                          disabled={!editState[`${qIndex}-null`]}
                        />
                        <TextField
                          label="Negative Feedback"
                          fullWidth
                          variant="standard"
                          value={question?.feedback?.[lang]?.neg ?? ""}
                          onChange={(e) =>
                            handleInputChange(
                              qIndex,
                              null,
                              e.target.value,
                              "negFeedback"
                            )
                          }
                          disabled={!editState[`${qIndex}-null`]}
                        />
                      </Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        my={2}
                        padding={2}
                      >
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          label="Attempts Allowed"
                          value={question.attemptsAllowed}
                          onChange={(e) =>
                            handleInputChange(
                              qIndex,
                              null,
                              e.target.value,
                              "attemptsAllowed"
                            )
                          }
                          disabled={!editState[`${qIndex}-null`]}
                          style={{ marginRight: 10 }}
                        />
                        <TextField
                          fullWidth
                          variant="standard"
                          select
                          label="Question Type"
                          value={question.type}
                          onChange={(e) =>
                            handleInputChange(
                              qIndex,
                              null,
                              e.target.value,
                              "type"
                            )
                          }
                          disabled={!editState[`${qIndex}-null`]}
                          style={{ marginRight: 10 }}
                        >
                          <MenuItem value="multipleChoice">
                            Multiple Choice
                          </MenuItem>
                          <MenuItem value="dragDropPair">
                            Drag And Drop Pairs
                          </MenuItem>{" "}
                          <MenuItem value="shortAnswer">shortAnswer </MenuItem>
                        </TextField>
                      </Box>
                      {question.answers.map((answer, aIndex) => {
                        if (question.type === "dragDropPair") {
                          return (
                            <div key={`${qIndex}-${aIndex}`}>
                              <DragDropAnswer
                                externalBookId={quiz.externalBookId}
                                editState={editState}
                                handleInputChange={handleInputChange}
                                handleMediaUpdate={handleMediaUpdate}
                                deleteAnswer={deleteAnswer}
                                answer={answer}
                                aIndex={aIndex}
                                qIndex={qIndex}
                                lang={lang}
                              />
                            </div>
                          );
                        }

                        return (
                          <div key={`${qIndex}-${aIndex}`}>
                            <Answer
                              externalBookId={quiz.externalBookId}
                              editState={editState}
                              handleInputChange={handleInputChange}
                              handleMediaUpdate={handleMediaUpdate}
                              deleteAnswer={deleteAnswer}
                              answer={answer}
                              aIndex={aIndex}
                              qIndex={qIndex}
                              lang={lang}
                            />
                          </div>
                        );
                      })}
                      {editState[`${qIndex}-null`] && (
                        <Button
                          color="info"
                          onClick={() => addAnswer(qIndex, question.id)}
                        >
                          Add Answer
                        </Button>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </>
      )}
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Button color="info" onClick={addQuestion}>
          Add Question
        </Button>
        <Button color="success" onClick={handleSaveAll} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Save All"}
        </Button>
      </Box>
    </Box>
  );
};

export default CrudQuizComponent;
